import { Modal } from "react-bootstrap";
import React from "react";

const ProjectModal = ({ setShow, show, info }) => {
  return (
    <Modal
      show={show}
      backdrop="static"
      centered
      onHide={() => setShow(false)}
      className="project-modal modal-bgstyle"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="border-0" closeButton>
        <Modal.Title id="example-custom-modal-styling-title"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center   ">
          <div className="card mb-3 border-0 m-2" style={{ maxWidth: "740px" }}>
            <div className="row g-0 d-flex justify-content-center ">
              <div className="col-md-4 tm-modal-media d-flex justify-content-center  pt-1">
                <img
                  src={info?.img.url}
                  className="img-fluid rounded-start "
                  alt="..."
                ></img>
              </div>
              <div className="col-md-8">
                <div className="card-body pt-0">
                  <h5 className="card-title">{info?.title1[0]?.text}</h5>
                  <p className="card-text">{info?.description1[0]?.text}</p>
                  {info?.external_link && (
                    <a
                      target="_blank"
                      className="text-decoration-none"
                      href={
                        info?.external_link ? info?.external_link?.[0]?.text : ""
                      }
                    >
                      <button type="button" className="  primary-btn">
                        Visit Website
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProjectModal;
